import { Component, OnInit, OnDestroy } from '@angular/core'
import { AuthService, CmsService, User } from '@spartacus/core'
import { DatePipe } from '@angular/common'
import { Observable, of } from 'rxjs'
import { filter, switchMap, take } from 'rxjs/operators'
import { LaunchDialogService } from '@spartacus/storefront'
import { UserAccountFacade } from '@spartacus/user/account/root'
import { DialogResponse, VS_LAUNCH_CALLER } from '../config/dialog.config'
import { BreadcrumbComponent } from '../../shared/components/breadcrumb/breadcrumb.component'
import { BreadcrumbService } from '../../shared/components/breadcrumb/breadcrumb.service'

@Component({
  standalone: false,

  selector: 'vs-landing-pages',
  templateUrl: './landing-pages.component.html',
})
export class LandingPagesComponent implements OnInit, OnDestroy {
  user$: Observable<User>
  isUserLoggedIn
  userType
  breadcrumbComponent: BreadcrumbComponent
  outageBannerComponent$: Observable<any> =
    this.cmsService.getComponentData<any>('VsOutageNotificationComponent')
  showOutageBanner = false

  outagePopupNotificationComponent$: Observable<any> =
    this.cmsService.getComponentData<any>('VsOutagePopupNotificationComponent')
  showOutagePopup = false
  outagePopupData: any
  todaysDate
  closingPopupDate
  closingBannerDate
  constructor(
    protected authService: AuthService,
    private breadcrumbService: BreadcrumbService,
    private cmsService: CmsService,
    private launchDialogService: LaunchDialogService,
    private datepipe: DatePipe,
    private userAccountFacade: UserAccountFacade
  ) {}
  ngOnInit(): void {
    this.todaysDate = this.datepipe.transform(new Date(), 'yyyy-MM-dd')
    this.closingPopupDate = JSON.parse(
      sessionStorage.getItem('closedPopupDate')
    )
    this.closingBannerDate = JSON.parse(
      sessionStorage.getItem('closedBannerDate')
    )
    this.user$ = this.authService.isUserLoggedIn().pipe(
      switchMap((isUserLoggedIn) => {
        this.isUserLoggedIn = isUserLoggedIn
        if (isUserLoggedIn) {
          this.userType = 'current'
          return this.userAccountFacade.get()
        } else {
          this.userType = 'anonymous'
          return of(undefined)
        }
      })
    )
    this.breadcrumbService.setShowHideBreadcrumb(false)
    // showOutageBanner should be fetch from Local Storage
    this.outageBannerComponent$.subscribe((res) => {
      if (res) {
        if (
          res.isAlwaysVisible == 'true' &&
          !sessionStorage.getItem('showOutageBanner')
        ) {
          this.showOutageBanner = true
          sessionStorage.setItem(
            'showOutageBanner',
            JSON.stringify(this.showOutageBanner)
          )
        } else {
          let validFrom = this.datepipe.transform(res.validFrom, 'yyyy-MM-dd')
          let validTill = this.datepipe.transform(res.validTill, 'yyyy-MM-dd')
          if (
            !sessionStorage.getItem('closedBannerDate') &&
            this.todaysDate >= validFrom &&
            this.todaysDate < validTill
          ) {
            this.showOutageBanner = true
            sessionStorage.setItem(
              'showOutageBanner',
              JSON.stringify(this.showOutageBanner)
            )
          } else if (
            !sessionStorage.getItem('showOutageBanner') &&
            this.closingBannerDate >= validFrom &&
            this.closingBannerDate < validTill
          ) {
            this.showOutageBanner = true
            sessionStorage.setItem(
              'showOutageBanner',
              JSON.stringify(this.showOutageBanner)
            )
          }
        }
      }
    })

    this.outagePopupNotificationComponent$.subscribe((res) => {
      if (res) {
        this.outagePopupData = res
        if (
          this.outagePopupData.isAlwaysVisible == 'true' &&
          this.userType == 'current' &&
          !sessionStorage.getItem('showOutagePopup')
        ) {
          this.showOutagePopup = true
          sessionStorage.setItem(
            'showOutagePopup',
            JSON.stringify(this.showOutagePopup)
          )
        } else {
          let validFrom = this.datepipe.transform(
            this.outagePopupData.validFrom,
            'yyyy-MM-dd'
          )
          let validTill = this.datepipe.transform(
            this.outagePopupData.validTill,
            'yyyy-MM-dd'
          )
          if (
            !sessionStorage.getItem('closedPopupDate') &&
            this.todaysDate >= validFrom &&
            this.todaysDate < validTill &&
            this.userType == 'current'
          ) {
            this.showOutagePopup = true
            sessionStorage.setItem(
              'showOutagePopup',
              JSON.stringify(this.showOutagePopup)
            )
          } else if (
            !sessionStorage.getItem('showOutagePopup') &&
            this.closingPopupDate >= validFrom &&
            this.closingPopupDate < validTill &&
            this.userType == 'current'
          ) {
            this.showOutagePopup = true
            sessionStorage.setItem(
              'showOutagePopup',
              JSON.stringify(this.showOutagePopup)
            )
          }
        }

        if (this.showOutagePopup) {
          const componentdata = {
            data: this.outagePopupData,
          }

          const outageNotificationDialog = this.launchDialogService.openDialog(
            VS_LAUNCH_CALLER.OUTAGE_NOTIFICATION,
            undefined,
            undefined,
            componentdata
          )
          if (outageNotificationDialog) {
            outageNotificationDialog.pipe(take(1)).subscribe((value) => {})
            this.launchDialogService.dialogClose
              .pipe(
                filter(
                  (dialogResponse: DialogResponse) =>
                    dialogResponse?.type == VS_LAUNCH_CALLER.OUTAGE_NOTIFICATION
                ),
                take(1)
              )
              .subscribe((value) => {
                if (value?.reason == 'close-outage') {
                  this.closeNotificationModal()
                }
              })
          }
        }
      }
    })
  }
  ngOnDestroy(): void {
    this.breadcrumbService.setShowHideBreadcrumb(true)
  }
  closeOutageBanner() {
    this.showOutageBanner = false
    sessionStorage.setItem('closedBannerDate', JSON.stringify(this.todaysDate))
    sessionStorage.setItem(
      'showOutageBanner',
      JSON.stringify(this.showOutageBanner)
    )
  }
  closeNotificationModal() {
    this.showOutagePopup = false
    sessionStorage.setItem('closedPopupDate', JSON.stringify(this.todaysDate))
    sessionStorage.setItem(
      'showOutagePopup',
      JSON.stringify(this.showOutagePopup)
    )
  }
}
